import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  IconButton,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Skeleton,
} from "@mui/material";
import React, { useEffect } from "react";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../Common/Dialog/DialogComponents";
import { ReactComponent as DeleteRoundIcon } from "../../Assets/Icons/DeleteRoundIcon.svg";
import { ReactComponent as Urgent } from "../../Assets/Icons/Urgent.svg";
import { makeStyles } from "@mui/styles";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { ReactComponent as Info } from "../../Assets/Icons/info.svg";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import { capitalizeFirstLetter } from "../../utils/generalUtils";
import { ReactComponent as DeleteIcon } from "../../Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "../../Assets/Icons/PharmsmartIcon/EditIcon.svg";
import { ReactComponent as AddPersonMainIcon } from "../../Assets/Icons/PharmsmartIcon/GroupIcon.svg";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import HomeLoader from "../../Components/Common/HomeLoader";
import moment from "moment";
const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
        },
      },
    },
  },
  dialogActionBtn: {
    marginBottom: "20px",
    "&>button": {
      width: "150px",
    },
  },
  iconStyle: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
    "&>path": {
      fill: "#5A6872",
    },
  },
  iconDeleteStyle: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
  },
  rsAlertIcon: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
    "&>path": {
      fill: "#5A6872",
      fillOpacity: "0.6",
    },
  },
  infoIcon: {
    marginLeft: "3px",
    marginBottom: "-9px",
    width: "20px",
    cursor: "pointer",
  },
  rsMainDialog: {
    paddingLeft: "30px",
    paddingRight: "30px",
    display: "flex",
    justifyContent: "space-between",
    "&>div": {
      "&>div": {
        "&>button": {
          "&>svg": {
            "&>path": {
              fill: "white !important",
            },
          },
        },
      },
    },
  },
  statusText: {
    border: "none !important",
    borderRadius: "10px !important",
    fontSize: "10px !important",
    height: "20px !important",
    marginLeft: "10px !important",
    marginRight: "3px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "white !important",
    display: "flex",
    alignItems: "center",
    "&>span": {
      fontSize: "10px",
      padding: "8px 8px",
    },
  },
  headerMain: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&>h4": {
      fontSize: "16px !important",
      fontWeight: "600 !important",
    },
  },
  hrStyle: {
    color: "black",
    width: "89%",
    height: "1px",
    marginLeft: "30px",
    marginRight: "30px",
    marginTop: "10px",
  },
  totalPatinet: {
    display: "flex !important",
    alignItems: "center !important",
    paddingLeft: "30px",
    paddingRight: "30px",
    paddingTop: "5px",
    "&>h6": {
      fontWeight: "400",
      fontSize: "12px",
      paddingRight: "5px",
    },
    "&>h5": {
      fontWeight: "500",
      fontSize: "16px",
      paddingRight: "5px",
    },
    "&>h2": {
      fontSize: "24px",
      fontWeight: "500",
    },
  },
  ludelete: {
    "&>div": {
      "&>button": {
        "&>svg": {
          "&>path": {
            fill: "white",
            stroke: "#FF5A5A",
          },
        },
      },
    },
  },
  rsPatientName: {
    display: "inline-flex",
    alignItems: "center",
    color: "#262626 !important",
    fontSize: "18px",
    fontWeight: "400",

    // display: "block !important",
  },
  tableBody: {
    paddingLeft: "30px",
    paddingRight: "30px",
    width: "100% !important",
    display: "block",
    "&>tr": {
      paddingLeft: "30px !important",
      paddingRight: "30px !important",
      width: "100% !important",
      "&>td": {
        padding: "0px 2px !important",
        width: "100% !important",
        borderWidth: "1px 0px 1px 1px !important",
        borderBottom: "1px solid black !important",
      },
    },
  },
  tableBodyLength: {
    paddingLeft: "30px",
    paddingRight: "30px",
    width: "100% !important",
    display: "block",
    "&>tr": {
      paddingLeft: "30px !important",
      paddingRight: "30px !important",
      width: "100% !important",
      "&>td": {
        padding: "0px 2px !important",
        width: "100% !important",
        borderWidth: "1px 0px 1px 1px !important",
        borderBottom: "0px solid #5a6872 !important",
      },
    },
  },
}));

const GroupDetailsDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    handleSubmit = () => {},
    loading = false,
    groupData,
    setGroupData,
    showDataBasedOnRole,
    setEditGroupData,
    setGroupRecordActionType,
    setIsOpenGroupModel,
    setGroupRecordDeleteActionType,
    setDeleteGroup,
    setGroupDeleteId,
    setPatientId,
    setPatientDetailOpen,
    setSelectedPatientId,
    getSingleGroupAction,
    singleGroup,
    groupId,
    setGroupId,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if(open){
      getSingleGroupAction(groupData?.g_id);
    }
  }, [groupData?.g_id, open]);

  return (
    <>
      <Dialog
        maxWidth={"sm"}
        open={open}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className="RSxs_modal"
      >
        {/* <PrimaryDialogTitle handleClose={handleClose} /> */}
        <Box className={classes.resConfirmationBox}>
          <DialogContent>
            <Box className={classes.rsMainDialog}>
              <Box className={classes.headerMain}>
                <Typography
                  variant="h4"
                  semiBold
                  color={"#262626"}
                  className={classes.rsGroupNamemain}
                  //   onClick={() => {
                  //     setGroupDailogOpen(true);
                  //     setGroupData(item);
                  //   }}
                  // className={classes.rsGroupName}
                >
                  {singleGroup?.loading ? (
                    <Box width="200px" height="50px">
                      <Skeleton height={"50px"} width={"100%"} />
                    </Box>
                  ) : (
                    capitalizeFirstLetter(singleGroup?.data?.g_name)
                  )}
                </Typography>
              </Box>

              <Box
                display={"flex"}
                paddingLeft={"10px"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Box marginTop={"-5px"}>
                  {showDataBasedOnRole !== "user" && (
                    <HtmlTooltipMain
                      title="Add Patient"
                      className={classes.hoverAlign}
                    >
                      <IconButton
                        className={classes.rsButtonHowtoIcon}
                        variant="contained"
                        onClick={() => {
                          setGroupRecordDeleteActionType("");
                          setGroupRecordActionType("addPatientInGroup");
                          setEditGroupData(singleGroup?.data);
                          setIsOpenGroupModel(true);
                          setGroupId(groupData?.g_id);
                        }}
                      >
                        <PrimaryIcon
                          height="19px"
                          icon={AddPersonMainIcon}
                          cursor="pointer"
                        />
                      </IconButton>
                    </HtmlTooltipMain>
                  )}
                  {showDataBasedOnRole !== "user" && (
                    <HtmlTooltipMain title="Edit Group">
                      <IconButton
                        className={classes.rsButtonHowtoIcon}
                        // className={classes.hoverAlign}
                        onClick={() => {
                          setGroupRecordDeleteActionType("");
                          setGroupRecordActionType("editGroupDetail");
                          setEditGroupData(singleGroup?.data);
                          setIsOpenGroupModel(true);
                          setGroupId(groupData?.g_id);
                        }}
                      >
                        <PrimaryIcon
                          color="secondary"
                          width="20px"
                          icon={EditIcon}
                          cursor="pointer"
                        />
                      </IconButton>
                    </HtmlTooltipMain>
                  )}
                  {showDataBasedOnRole !== "user" && (
                    <HtmlTooltipMain title="Delete Group">
                      <IconButton
                        className={classes.rsButtonHowtoIcon}
                        // className={classes.hoverAlign}
                        onClick={() => {
                          setGroupRecordDeleteActionType("groupDelete");
                          setDeleteGroup(true);
                          setGroupDeleteId(groupData?.g_id);
                          setGroupId(groupData?.g_id);
                        }}
                      >
                        <PrimaryIcon
                          height="19px"
                          icon={DeleteIcon}
                          cursor="pointer"
                        />
                      </IconButton>
                    </HtmlTooltipMain>
                  )}
                </Box>
              </Box>
            </Box>
            <hr className={classes.hrStyle} />
            {/* <Box className={classes.totalPatinet}>
              <Typography variant="h6">Next Order Date:</Typography>
              <Typography variant="h5">
                {singleGroup?.loading ? (
                  <Box width="200px" height="50px">
                    <Skeleton height={"50px"} width={"100%"} />
                  </Box>
                ) : singleGroup?.data?.g_order_date ? (
                  moment(new Date(singleGroup?.data?.g_order_date)).format(
                    "DD-MM-YYYY"
                  ) || "N / A"
                ) : (
                  "N / A"
                )}
              </Typography>
            </Box> */}
            {/* <Box className={classes.totalPatinet}>
              <Typography variant="h6">Cycle Day:</Typography>
              <Typography variant="h5">
                {singleGroup?.loading ? (
                  <Box width="200px" height="50px">
                    <Skeleton height={"50px"} width={"100%"} />
                  </Box>
                ) : singleGroup?.data?.g_cycle_day ? (
                  singleGroup?.data?.g_cycle_day
                ) : (
                  "N / A"
                )}
              </Typography>
            </Box> */}
            <Box className={classes.totalPatinet}>
              <Typography variant="h6">Total Patient:</Typography>
              <Typography variant="h2">
                {singleGroup?.loading ? (
                  <Box width="200px" height="50px">
                    <Skeleton height={"50px"} width={"100%"} />
                  </Box>
                ) : (
                  singleGroup?.data?.patient_count
                )}
              </Typography>
            </Box>
            <Box paddingLeft={"30px"} paddingRight={"30px"}>
              <TableBody
                className={
                  singleGroup?.data?.patient_info?.length > 0
                    ? classes.tableBody
                    : classes.tableBodyLength
                }
              >
                {singleGroup?.loading ? (
                  <>
                    <Skeleton height={"50px"} width={"500px"} />
                    <Skeleton height={"50px"} width={"500px"} />
                  </>
                ) : singleGroup?.data?.patient_info?.length > 0 ? (
                  singleGroup?.data?.patient_info?.map((patientList, index) => {
                    return (
                      <TableRow>
                        <TableCell semiBold>
                          <Box
                            display={"flex"}
                            className={classes.rsPatientName}
                          >
                            <Box
                              className="cursor-pointer"
                              onClick={(event) => {
                                // setDetailsDialog(true);
                                // setPatientDetails(item);
                                setPatientId(patientList?.pg_pi_id);
                                setPatientDetailOpen(true);
                              }}
                            >
                              {patientList?.name}
                              {` `}
                              {patientList?.last_name}
                            </Box>
                            {groupData?.status !== "Active" && (
                              <Chip
                                label={
                                  patientList?.status === "Active"
                                    ? null
                                    : patientList?.status
                                }
                                variant="outlined"
                                className={classes.statusText}
                                style={{
                                  backgroundColor: (() => {
                                    if (patientList?.status === "Absent") {
                                      return "rgba(107, 107, 107,0.6)";
                                    } else if (
                                      patientList?.status === "In-Hospital"
                                    ) {
                                      return "rgba(210, 162, 68,0.6)";
                                    } else if (
                                      patientList?.status === "Deceased"
                                    ) {
                                      return "rgba(255, 0, 0,0.6)";
                                    }
                                  })(),
                                  color: (() => {
                                    if (patientList?.status === "Absent") {
                                      return "white";
                                    } else if (
                                      patientList?.status === "In-Hospital"
                                    ) {
                                      return "white";
                                    } else {
                                      return "white";
                                    }
                                  })(),
                                }}
                              />
                            )}
                          </Box>
                        </TableCell>
                        {showDataBasedOnRole !== "user" && (
                          <TableCell className={classes.ludelete}>
                            <Box display={"flex"} alignItems={"center"}>
                              <HtmlTooltipMain title="Remove Patient">
                                <IconButton
                                  className={classes.hoverAlign}
                                  onClick={() => {
                                    setGroupRecordDeleteActionType(
                                      "patientDelete"
                                    );
                                    setEditGroupData(singleGroup?.data);
                                    setDeleteGroup(true);
                                    setGroupDeleteId(singleGroup?.data?.g_id);
                                    setSelectedPatientId(patientList?.pg_pi_id);
                                    setGroupId(groupData?.g_id);
                                  }}
                                >
                                  <PrimaryIcon
                                    height="19px"
                                    icon={DeleteIcon}
                                    cursor="pointer"
                                  />
                                </IconButton>
                              </HtmlTooltipMain>
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableEmptyState />
                )}
              </TableBody>
            </Box>
          </DialogContent>
        </Box>

        <DialogActions className={classes.dialogActionBtn}>
          {/* <Button
            variant="contained"
            disabled={loading}
            startIcon={
              loading && <CircularProgress size ="20px" color="white" />
            }
            type="submit"
            onClick={() => {
              handleSubmit();
              // setCreateMultiOrder(true);
            }}
          >
            Ok
          </Button> */}
          <Button className="BtnGreen" variant="outlined" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GroupDetailsDialog;
